@if (packageType$ | async; as packageType) {
  <elder-basic-pane-layout class="full p-pane" elderPlugParentForm>
    <elder-pane class="flex layout-col outlined p-pane">
      <elder-pane-subtitle>{{ 'context.dimension' | translate }}</elder-pane-subtitle>
      <div class="layout-row">
        <mat-form-field>
          <elder-dimensions-input
            name="presetDimensions"
            [(ngModel)]="packageType.presetDimensions"
          >
          </elder-dimensions-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </div>
    </elder-pane>
    <elder-pane class="flex layout-col outlined">
      <elder-pane-subtitle class="p-pane">
        {{ 'packages.packagingMaterial' | translate }}
      </elder-pane-subtitle>
      @if (supportedPackagingMaterialsDs$ | async; as supportedPackagingMaterialsDs) {
        <app-package-type-material-table
          class="flex"
          [packagingMaterialSpecs]="supportedPackagingMaterialsDs"
        >
        </app-package-type-material-table>
      }
    </elder-pane>
  </elder-basic-pane-layout>
}
